import React, { useState } from "react";
import './AboutModal.css';

const AboutModal = ({ show, onClose, content }) => {
  if (!show) return null;
  return (
    <div className="about-modal-overlay">
      <div className="about-modal">
        <button className="about-modal-close" onClick={onClose}>&times;</button>
        <div className="about-modal-content">
          {content}
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
